import { useCallback, useEffect, useMemo, useState } from "react"

import { Option } from "../utils"
let timer
interface useLoadMoreProps {
  options: Option[]
}
export const useLoadMore = (props: useLoadMoreProps) => {
  const { options } = props
  const [page, setPage] = useState(1)
  const handleScrollBottom = useCallback(() => {
    timer && clearTimeout(timer)
    timer = setTimeout(() => {
      setPage((page) => page + 1)
    }, 50)
  }, [])
  const renderOptions = useMemo(() => {
    return options.slice(0, page * 20)
  }, [options, page])

  useEffect(() => {
    setPage(1)
  }, [options])
  return {
    handleScrollBottom,
    renderOptions,
  }
}
